<script setup>
import GlobalFooter from '@/components/GlobalFooter.vue'
import {onMounted, onUnmounted} from "vue";
import { useRouter } from "vue-router";
import DescriptionHeader from "@/components/DescriptionHeader.vue";
import {useOrderDataStore} from "@/stores/orderDataStore";
import {useI18n} from "vue-i18n";

const router = useRouter();
const orderDataStore = useOrderDataStore();
const {t} = useI18n();

// https://stackoverflow.com/questions/62006005/redirect-to-a-url-when-browser-back-button-is-pressed-using-javascript
onMounted(() => {
  // Replace history to prevent back navigation
  history.pushState("","", location.href);
  window.addEventListener("popstate", handleBackNavigation);
});
onUnmounted(() => {
  window.removeEventListener("popstate", handleBackNavigation);
});

const handleBackNavigation = () => {
  router.replace("/"); // Redirect to login page when back button is pressed
};

</script>

<template>

  <div class="flex flex-col min-h-screen w-full">
    <div class="flex-grow">
      <div class="grid justify-center items-center pt-10" >
        <img src="@/assets/tfp_logo.svg" alt="TFP logo" class="h-12 w-auto">
      </div>
      <div class="grid place-content-center my-10"></div>

      <div>

        <DescriptionHeader :label="t('successRequest.header')"/>

        <div class="flex flex-col justify-center items-center">
          <div class="grid bg-background-white place-items-center text-center responsive-body-large border px-6 py-5 mt-10 mb-4 relative overflow-hidden container">
            <span>{{ t('successRequest.message1') }}</span><br>
            <span>{{ t('successRequest.message2') }}</span><br>
            <span class="responsive-body-medium italic">{{ t('successRequest.rmaLabel') }}: {{ orderDataStore.rmaId }}</span><br>
            <img src="@/assets/success_icon_black.png" alt="Summary Icon" class="ml-2 w-20 h-20 block">
          </div>
        </div>
      </div>


      <div  class="flex flex-col justify-center items-center">
        <a href="https://www.thefashionproject.gr/" class="container border rounded overflow-hidden bg-bw-black text-bw-white responsive-body-large text-center mb-1 py-3.5 px-1 hover:bg-bw-darkGrey focus:outline-2 focus:outline-offset-2 focus:outline-bw-black">{{ t('successRequest.backToSite') }}</a>
      </div>
    </div>

    <GlobalFooter></GlobalFooter>
  </div>

</template>

